export const MAXIMUM_PAGINATION = 1000;

export const AUTOCOMPLETE_PAGE_SIZE = 10;

export const AUTOCOMPLETE_STALE_TIME = 10 * 1000;

export const DEFAULT_PAGE = 1;

export const CACHE_TIME = 2 * 1000;
